<!-- <div *ngIf="messageService.message.length">
    <div class="alert alert-{{ messageService.type }}" role="alert">
        {{ messageService.message }}
    </div>
</div> -->

<div class="message-container">
  <div class="message-content">
    <i class="material-icons message-icon">info</i>
    <span class="message-text">{{ data }}</span>
  </div>
</div>